<template>
  <NewgameWrapper ref="newGameWrapper" :location="2" :showBottomNav="true">
    <div v-if="!showSearch">
      <div :class="$style.top">
        <p>游戏中心</p>
        <!-- 搜索栏（暂时隐藏上） -->
        <div :class="$style.search">
          <div :class="$style.searchbar" @click="showSearchPage">
            <div :class="$style['searchbar-left']">
              <img :src="searchImg" alt="搜索小图标" />
            </div>
            <div :class="$style['searchbar-content']">
              <input placeholder="搜索你想玩的游戏~" />
            </div>
          </div>
        </div>
        <div :class="$style.tabs">
          <span :class="[actTab == 0 && $style.active]" @click="setTab(0)">游戏推荐</span>
          <span :class="[actTab == 1 && $style.active]" @click="setTab(1)">热游排行榜</span>
        </div>
      </div>
      <!-- 游戏推荐 -->
      <div :class="$style.gameRecommend" v-if="!actTab">
        <!-- 热门游戏 -->
        <div :class="$style.hot">
          <img :src="hotIcon" alt="" />
          <div :class="$style.gameList">
            <div v-for="(item, index) in hotList" :key="index" :class="$style.gameItem">
              <img :src="item.main_image" alt="" />
              <p :class="$style.name">{{ item.name }}</p>
              <p :class="$style.tags">
                <span v-for="(tag, tgi) in item.label" :key="tgi" v-if="tag.value">{{ tag.value }}</span>
              </p>
              <div :class="$style.download" @click="download(item, 1)">下载</div>
            </div>
          </div>
        </div>
        <!-- 游戏板块 -->
        <div :class="$style.plate">
          <div v-for="(p, pi) in plateList" :key="pi" :class="$style.pi">
            <p :class="$style.name">{{ p.name }}</p>
            <div v-for="(g, gi) in p.game" :key="gi" :class="$style.gi">
              <div>
                <img :src="g.images" alt="" :class="$style.icon">
                <div :class="$style.text">
                  <p :class="$style.name">{{ g.name }}</p>
                  <p :class="$style.desc">{{g.description}}</p>
                  <p :class="$style.tags">
                    <span v-for="(tag, tgi) in g.label" :key="tgi" :style="{ border: `1px solid ${tag.color}`, color: tag.color }" v-if="tag.value">{{ tag.value }}</span>
                  </p>
                </div>
                <div :class="$style.download" @click="download(g, 2)">下载</div>
              </div>
              <img :src="g.main_image" alt="" :class="$style.main" v-if="g.main_image">
            </div>
          </div>
        </div>
      </div>
      <!-- 热游推荐榜 -->
      <div :class="$style.gameRecommend" v-else>
        <div v-for="(r, ri) in rankList" :key="ri" :class="$style.ri">
          <div :class="$style.rankIcon" v-if="ri === 0" :style="{ backgroundImage: `url(${CDN_URL}/gameCenter/v2/7.png)` }"></div>
          <div :class="$style.rankIcon" v-else-if="ri === 1" :style="{ backgroundImage: `url(${CDN_URL}/gameCenter/v2/9.png)` }"></div>
          <div :class="$style.rankIcon" v-else-if="ri === 2" :style="{ backgroundImage: `url(${CDN_URL}/gameCenter/v2/8.png)` }"></div>
          <div :class="$style.rankIcon" v-else></div>
          <div :class="$style.gameItem">
            <img :src="r.images" alt="">
            <div :class="$style.content">
              <p :class="$style.name">{{ r.name }}</p>
              <p :class="$style.desc">{{ r.description }}</p>
              <p :class="$style.tags" v-if="r.label">
                <span v-for="(tag, tgi) in r.label" :key="tgi" :style="{ border: `1px solid ${tag.color}`, color: tag.color }" v-if="tag.value">{{ tag.value }}</span>
              </p>
            </div>
          </div>
          <div  :class="$style.download" @click="download(r, 3)">下载</div>
        </div>
      </div>
    </div>
    <!-- 搜索模块 -->
    <div v-else :class="$style.searchPage">
      <div :class="$style.search">
        <img :src="`${$cdnUrl}/tgStore/xiangzuo.png`" alt="" @click="showSearch=false">
        <input placeholder="搜索你想玩的游戏" v-model="keyword" maxlength="10" />
        <span @click="searchData">搜索</span>
      </div>
      <p :class="$style.noRes" v-if="noRes">暂无搜索结果</p>
      <div :class="$style.resList" v-if="resList.length">
        <div v-for="(r, ri) in resList" :key="ri">
          <img :src="r.images" alt="">
          <div :class="$style.content">
            <p :class="$style.name">{{ r.name }}</p>
            <p :class="$style.desc">{{ r.description }}</p>
            <p :class="$style.tags" v-if="r.label">
              <span v-for="(tag, tgi) in r.label" :key="tgi"  :style="{ border: `1px solid ${tag.color}`, color: tag.color }" v-if="tag.value">{{ tag.value }}</span>
            </p>
          </div>
          <div :class="$style.download" @click="download(r, 4)">下载</div>
        </div>
      </div>
    </div>
  </NewgameWrapper>
</template>

<script>
import NewgameWrapper from '_c/NewgameWrapper';
import Scroll from '_c/Scroll';
import CircleBaseBox from '_c/CircleBaseBox';
import AdvertisingBanner from '_c/AdvertisingBanner';
import HmGameHorizontal from './components/HmGameHorizontal';
import HmGameVertical from './components/HmGameVertical';
import Search from './components/Search';
import { getHmGameList, getHotList, getRankList, getPlateList, getSearchList, reportDataApi } from '@/api/gameCenter';
import { reportData } from '@/api/report';
import { mapActions, mapState, mapMutations } from 'vuex';
import { CDN_URL } from '@/config/index.js';
export default {
  components: {
    NewgameWrapper,
    Scroll,
    CircleBaseBox,
    AdvertisingBanner,
    HmGameHorizontal,
    HmGameVertical,
    Search,
  },
  data() {
    return {
      // hmGameList: [],
      CDN_URL: CDN_URL,
      searchImg: `${CDN_URL}/gameCenter/v2/6.png`, // 搜索小图标
      hotIcon: `${CDN_URL}/gameCenter/v2/5.png`, // 搜索小图标
      showSearch: false, // 是否显示搜索模块
      actTab: 0, // 0.游戏推荐 1.热游推荐榜
      noRes: false,
      hotList: [],
      rankList: [],
      plateList: [],
      keyword: '',
      resList: []
    };
  },
  computed: {
    ...mapState('account', {
      userInfo: (state) => state.userInfo, // 当前用户信息
    }),
  },
  created() {
    this.getHmGameList();
  },
  mounted() {
    reportData({
      type: 17,
      data_type: 1,
      page_type: 1,
    });
  },
  methods: {
    ...mapMutations('app', {
      CHANGE_SHOW_LOADING: 'CHANGE_SHOW_LOADING',
    }),
    showSearchPage() {
      this.showSearch = true;
      this.resList = [];
      this.noRes = false;
      reportData({
        type: 17,
        data_type: 2,
        page_type: this.actTab ? 2 : 1
      });
    },
    download(item, download_url_type) {
      reportData({
        type: 17,
        data_type: 4,
        download_url_type: download_url_type,
        game_id: item.id,
        game_name: item.name,       
      });
      setTimeout(() => {
        window.location.href = item.download_url;
      }, 500)
    },
    // 获取游戏中心游戏列表
    async getHmGameList() {
      // this.CHANGE_SHOW_LOADING(true);
      // const r = await getHmGameList();
      // this.hmGameList = [...r.data];
      // this.CHANGE_SHOW_LOADING(false);
      const hotList = await getHotList();
      this.hotList = hotList.data
      const rankList = await getRankList();
      this.rankList = rankList.data
      const plateList = await getPlateList();
      this.plateList = plateList.data
    },
    async searchData() {
      const r = await getSearchList(this.keyword);
      this.resList = r.data;
      if (!this.resList.length) {
        this.noRes = true
      } else {
        this.noRes = false
      }
      reportData({
        type: 17,
        data_type: 5,
        keyword: this.keyword
      });
    },
    // 点击返回
    handleBack() {
      this.$router.go(-1);
    },
    // 下拉加载
    bsPullingDown() {
      this.getHmGameList();
      setTimeout(() => {
        this.$refs.scroll && this.$refs.scroll.refresh();
      }, 10);
    },
    setTab(tab) {
      this.actTab = tab;
      reportData({
        type: 17,
        data_type: 3,
        page_type: tab ? 2 : 1
      });
      reportData({
        type: 17,
        data_type: 1,
        page_type: tab ? 2 : 1
      });
    }
  },
};
</script>

<style lang="scss" module>
@import '~@/styles/mixins.scss';
@import '~@/styles/animation.scss';
@import '~@/styles/_variable.scss';
.box-slide-up {
  @include newgame-home-slide-up;
}
.box-slide-down {
  @include newgame-home-slide-down;
}
.box {
  width: 100%;
  height: calc(100vh - 60px);
  > div {
    min-height: 100vh;
  }
}
.top {
  width: 100%;
  min-height: 150px;
  margin-bottom: 8px;
  position: relative;
  background-repeat: no-repeat;
  background-size: 100%;
  background-color: #d33d3e;
  color: #ffffff;
  text-align: center;
  font-size: 18px;
  padding-top: 20px;
  > p {
    font-weight: 700;
  }
  // 搜索栏
  .search {
    width: 100%;
    height: 70px;
    .searchbar {
      position: absolute;
      top: 58px;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      box-shadow: 0px 3px 6px 0px rgba(60, 10, 10, 0.2);
      border-radius: 14px;
      background-color: rgba(255, 255, 255, 0.3);
      width: 353.82px;
      height: 34.03px;
      border-radius: 6.94px;
      .searchbar-left {
        width: 30px;
        height: 100%;
        padding: 10px 0px 0px 22px;
        margin-right: 18px;
        display: flex;
        > img {
          width: 14px;
          height: 14px;
        }
      }
      .searchbar-content {
        width: 180px;
        height: 100%;
        font-size: 14px;
        padding: 5px 0px 2px 0px;
        > input {
          width: 100%;
          height: 25px;
          line-height: 25px;
          background-color: transparent;
          &::placeholder {
            color: #ffffff;
          }
        }
      }
      .searchbar-right {
        width: 30px;
        line-height: 29px;
        font-size: 12px;
        font-weight: 400;
      }
    }
  }
  .tabs {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    > span {
      margin: 0 0 0 24px;
      font-size: 18px;
      &.active {
        font-weight: 700;
        font-size: 20px;
        position: relative;
        &::before {
          position: absolute;
          content: ' ';
          bottom: -8px;
          left: 0;
          right: 0;
          margin: auto;
          width: 14.93px;
          height: 4.17px;
          background-image: url('#{$cdn-url-hm}/gameCenter/v2/1.png');
          background-size: 100% 100%;
        }
      }
    }
  }
}
.gameRecommend {
  width: 100%;
  background-color: #f6f6f6;
  .hot {
    width: 354.17px;
    height: 230.56px;
    background: #ffffff;
    border-radius: 6.94px;
    padding: 12px 10px;
    margin: auto;
    margin-bottom: 10px;
    > img {
      display: block;
      width: 71.88px;
      height: 19.1px;
      margin-bottom: 16px;
    }
    .gameList {
      width: 100%;
      overflow-x: auto;
      display: flex;
      padding-bottom: 5px;
      .gameItem {
        flex-shrink: 0;
        width: 131.94px;
        height: 159.72px;
        background: #ffffff;
        border-radius: 6.94px;
        box-shadow: -1.39px 0px 2.08px 1.39px rgba(163, 163, 163, 0.28);
        margin-right: 10px;
        overflow: hidden;
        > img {
          width: 100%;
          height: 69px;
          margin-bottom: 10px;
        }
        .name {
          font-size: 12.5px;
          font-weight: 500;
          text-align: center;
          color: #333333;
          margin-bottom: 10px;
        }
        .tags {
          display: flex;
          align-items: center;
          justify-content: center;
          > span {
            font-size: 10px;
            padding: 2px 4px;
            border: 1PX solid #dedede;
            border-radius: 1.39px;
            margin-right: 4px;
            color: #afafaf;
          }
        }
        .download {
          width: 59.03px;
          height: 24.31px;
          background: #f1f4fd;
          border: 1PX solid #e3eaff;
          border-radius: 12.85px;
          display: flex;
          align-items: center;
          font-size: 11px;
          justify-content: center;
          color: #6879ad;
          margin: auto;
          margin-top: 8px;
        }
      }
    }
  }
  .plate {
    > .pi {
      width: 354.17px;
      background: #ffffff;
      border-radius: 6.94px;
      margin: auto;
      padding: 15px 10px;
      margin-bottom: 10px;
      > .name {
        font-size: 16.67px;
        font-weight: 700;
        text-align: left;
        color: #010101;
        margin-bottom: 14px;
      }
      > .gi {
        margin-bottom: 10px;
        > div {
          display: flex;
          align-items: center;
          margin-bottom: 8px;
          position: relative;
          width: 326.39px;
          margin: auto;
          margin-bottom: 10px;
          > img {
            width: 58.33px;
            height: 58.33px;
            border-radius: 5px;
            margin-right: 7px;
          }
          > .text {
            > .name {
              font-size: 14.58px;
              font-weight: 500;
              text-align: left;
              color: #333333;
              margin-bottom: 8px;
            }
            .desc {
              font-size: 11.11px;
              font-weight: 400;
              color: #999999; 
              width: 190px;
              margin-bottom: 5px;
            }
            .tags {
              > span {
                font-size: 10px;
                display: inline-block;
                border-radius: 1.39px;
                padding: 2px 4px;
                margin-right: 4px;
                text-align: center;
              }
            }
          }
          .download {
            position: absolute;
            right: 0px;
            width: 59.03px;
            height: 24.31px;
            border: 1PX solid #fc5f5e;
            border-radius: 12.85px;
            color: #FC5F5E;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
        > .main {
          display: block;
          width: 326.39px;
          height: 183.68px;
          border-radius: 8px;
          margin: auto;
        }
      }
    }

  }
  .ri {
    width: 100%;
    position: relative;
    padding: 10px 10px;
    display: flex;
    align-items: center;
    .rankIcon {
      width: 35.07px;
      height: 31.6px;
      background-size: 100% 100%;
      margin-right: 10px;
    }
    .gameItem {
      display: flex;
      align-items: center;
      > img {
        width: 58.33px;
        height: 58.33px; 
        border-radius: 8px;
        margin-right: 10px;
      }
      .content {
        .name {
          height: 13.89px;
          font-size: 14.58px;
          font-weight: 700;
          text-align: left;
          color: #000000;
          margin-bottom: 10px;
        }
        .desc {
          height: 10.42px;
          font-size: 11.11px;
          font-weight: 400;
          text-align: left;
          color: #858585;
          margin-bottom: 5px;
        }

        .tags {
          > span {
            font-size: 10px;
            display: inline-block;
            border-radius: 1.39px;
            padding: 2px 4px;
            margin-right: 4px;
            text-align: center;
          }
        }
      }
    }
    .download {
      position: absolute;
      right: 15px;
      width: 80.21px;
      height: 27.08px;
      background: linear-gradient(-87deg,#ff5443 0%, #fe7b2b 100%) #000000;
      border-radius: 13.54px;
      color: #FFFFFF;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}

.searchPage {
  background-color: #ffffff;
  min-height: 800px;
  .search {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 8px;
    margin-bottom: 15px;
    > img {
      width: 7.29px;
      height: 16.67px;
      margin-right: 20px;
    }
    > input {
      padding-left: 15px;
      width: 274.31px;
      height: 36px;
      line-height: 36px;
      background: #f0f0f0;
      border-radius: 17.36px;
      margin-right: 15px;
    }
    > span {
      font-size: 12.5px;
      color: #48aceb;
    }
  }
  .noRes {
    font-size: 12.5px;
    font-weight: 400;
    text-align: center;
    color: #505050;
  }
  .resList {
    > div {
      display: flex;
      align-items: center;
      position: relative;
      padding: 0 20px;
      margin-bottom: 20px;
      > img {
        width: 58.33px;
        height: 58.33px; 
        border-radius: 8px;
        margin-right: 10px;
      }
      .content {
        .name {
          height: 13.89px;
          font-size: 14.58px;
          font-weight: 700;
          text-align: left;
          color: #000000;
          margin-bottom: 10px;
        }
        .desc {
          height: 10.42px;
          font-size: 11.11px;
          font-weight: 400;
          text-align: left;
          color: #858585;
          margin-bottom: 5px;
        }

        .tags {
          > span {
            font-size: 10px;
            display: inline-block;
            border-radius: 1.39px;
            padding: 2px 4px;
            margin-right: 4px;
            text-align: center;
          }
        }
      }
      .download {
        position: absolute;
        right: 20px;
        width: 59.03px;
        height: 24.31px;
        border: 1PX solid #fc5f5e;
        border-radius: 12.85px;
        color: #FC5F5E;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
</style>
